function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Path, {
  d: "M39.389 13.769L22.235 28.606H6v19.093h15.989l17.4 15.051V13.769z",
  stroke: "#00245a",
  strokeWidth: 5,
  strokeLinejoin: "round",
  fill: "#00245a"
});

var _ref2 = /*#__PURE__*/React.createElement(Path, {
  d: "M48 27.6A19.5 19.5 0 0148 49m7.1-28.5a30 30 0 010 35.6M61.6 14a38.8 38.8 0 010 48.6",
  fill: "none",
  stroke: "#111",
  strokeWidth: 5,
  strokeLinecap: "round"
});

function SvgTempIconSound(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 75 75"
  }, props), _ref, _ref2);
}

export default SvgTempIconSound;